module.exports = __webpack_public_path__ + "static/media/shu_logo.3ccc367f.svg";